query getValuationsPaginated($input: GetValuationsPaginatedInput!) {
  getValuationsPaginated(input: $input) {
    hasMore
    valuations {
      id
      userId
      createdAt
      leadId
      inputs {
        type
        address {
          street
          houseNumber
          city
          zip
        }
      }
      results {
        property {
          value
        }
        currency
      }
      pdf {
        status
      }
    }
  }
}
